import React from "react";
import styled from "styled-components";
import { font, defaultFont } from "../../../theme/typography";
import { black300 } from "../../../theme/colors";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import { Modal } from "../../../components/Modal";
import { ActionButton } from "../organization-roles-users/roles/role-styles";
import { Error } from "@material-ui/icons";

const ContentStyle = styled.div`
  margin-top: 30px;
  b {
    font-size: ${font.smallmedium};
    line-height: 125%;
  }
  p {
    width: 263px;
    margin: 8px auto 32px;
  }
  ${defaultFont}
  text-align:center;
`;

export const ConfirmationModal = ({
  open,
  backgroundColor,
  avoidDelete,
  noAction,
  hideBoxShadow,
  yesAction,
  confirmationText = `You have unsaved changes. 
    Are you sure you want to leave this page?`,
  proceedText = '',
  closeAction = () => { },
  actionText = 'Yes',
  cancelText = 'No',
  headerText = 'Confirmation',
  customElement = null
}) => {
  if (!open) {
    return null;
  }

  return (
    <Modal
      modalWidth="500px"
      modalHeight="auto"
      withHeader
      closeAction={closeAction}
      backDropOpacity={0.3}
      closeIconColor={black300}
    >
      <ContentStyle style={{
        backgroundColor: 'white',
        padding: '8px 16px',
        borderRadius: '8px',
        // boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '100%'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '8px'
        }}>
          {headerText === "ALERT" && (
            <Error
              style={{
                color: "red",
                fontSize: "400%",
                marginBottom: "4px"
              }}
            />
          )}
          <b style={{ fontSize: '18px' }}>{headerText}</b>
        </div>
        <p style={{
          whiteSpace: "pre-line",
          fontSize: '14px',
          color: '#333',
          margin: '4px auto',
          maxWidth: '80%'
        }}>
          {confirmationText}
        </p>
        <p>{proceedText}</p>
        {customElement}

        {!avoidDelete && (
          <>
            {noAction && (
              <ActionButton onClick={noAction}>
                <CloseIcon />
                {cancelText}
              </ActionButton>
            )}
            {yesAction && (
              <ActionButton active={true} onClick={yesAction}>
                <DoneIcon />
                {actionText}
              </ActionButton>
            )}
          </>
        )}
      </ContentStyle>

    </Modal>

  );
};
